import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';
import { controlDisabled, controlFocus, controlInvalid, controlSurface } from '../lib/control';

export type InputProps = ComponentProps<'input'>;

export function Input({ className, type = 'text', ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-(--control-h) w-full min-w-0 px-3 py-1 text-body file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-body-sm file:font-medium file:text-foreground',
        controlSurface,
        controlFocus,
        controlInvalid,
        controlDisabled,
        className,
      )}
      {...props}
    />
  );
}
